import { Button } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import {
  RequestForInvoicingStatusEnum,
  useCreateRequestForInvoicingMutation,
  useUpdateRequestForInvoicingMutation,
} from "@src/__generated__/graphql";
import { routeHistory } from "@src/helpers/route-history";
import { onError } from "@src/utils/apollo";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { InvoiceTypeEnum, useInvoiceStore } from "../../store";

export const SubmitForInvoiceButton = observer(
  function SubmitForInvoiceButton() {
    const store = useInvoiceStore();
    const router = useRouter();

    const [createMutation, createRequest] =
      useCreateRequestForInvoicingMutation({
        async onCompleted(data) {
          if (store.isTimeAndMaterialsSelected) {
            await store.timeAndMaterialsStore.saveFiltersAsTemplate(
              data.createRequestForInvoicing.id,
              "rfi",
            );
          }
          router.push(routeHistory.get("/invoices/for-invoicing"));
        },
        ...onError(),
      });

    const [updateMutation, updateRequest] =
      useUpdateRequestForInvoicingMutation({
        onCompleted() {
          router.push(routeHistory.get("/invoices/for-invoicing"));
        },
        ...onError(),
      });

    store.setInvoiceMutationLoading(
      createRequest.loading || updateRequest.loading,
    );

    const onCreateRequestForInvoice = async () => {
      const { hasError } = await store.validateAllSteps(true);
      if (hasError) return;

      if (store.invoice_id) {
        if (store.isTimeAndMaterialsSelected) {
          await store.timeAndMaterialsStore.saveFiltersAsTemplate(
            store.invoice_id,
            "rfi",
          );
        }

        updateMutation({
          variables: {
            input: store.updateRequestForInvoiceInput(
              RequestForInvoicingStatusEnum.Submitted,
            ),
            skip_date_validations: store.skip_date_validations,
          },
        });
      } else {
        createMutation({
          variables: {
            input: store.createRequestForInvoiceInput(
              RequestForInvoicingStatusEnum.Submitted,
            ),
            skip_date_validations: store.skip_date_validations,
          },
        });
      }
    };

    return (
      <Button
        isLoading={
          store.convertAmountFetcher.isLoading.value ||
          store.exchangeRateFetcher.isLoading.value
        }
        onClick={onCreateRequestForInvoice}
      >
        {store.type === InvoiceTypeEnum.Proforma
          ? t`Submit a proforma`
          : t`Submit for invoicing`}
      </Button>
    );
  },
);
